<ng-container *ngIf="isLoading">
	<div class="overlay"></div>
	<div class="k-loading-image z-index-100"></div>
</ng-container>